import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/site';
import { categories as catList } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">
                果冻传媒
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed mb-4">
              {siteInfo.tagline}
            </p>
            <div className="flex items-center gap-3">
              {siteInfo.socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-primary-500 transition-colors cursor-pointer"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-bold mb-4 text-base">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { name: '首页', path: '/' },
                { name: '全部分类', path: '/category/all' },
                { name: '排行榜', path: '/category/all?sort=hot' },
                { name: '最新上线', path: '/category/all?sort=new' },
                { name: '关于我们', path: '/about' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-bold mb-4 text-base">内容分类</h4>
            <div className="flex flex-col gap-2.5">
              {catList.filter(c => c.id !== 'all').slice(0, 6).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-heading font-bold mb-4 text-base">联系我们</h4>
            <div className="flex flex-col gap-2.5 text-sm text-background-50/60">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>{siteInfo.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>{siteInfo.phone}</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">{siteInfo.copyright}</p>
          <div className="flex items-center gap-6 text-sm text-background-50/40">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}